import { Link, Popover } from "@mui/material";
import LoadingImage from "components/LoadingImage";
import { useTranslation } from "react-i18next";

const AssignmentProfilePopup = (props: any) => {
  const { id, open, anchorEl, handleClose, handleLogout, logoutLoading } = props;
  const { t } = useTranslation();

  if (!open) {
    return null;
  }

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      slotProps={{
        paper: {
          sx: {
            p: "16px 12px", // Adjusted padding
            borderRadius: "12px", // Adjusted border radius
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)", // Adjusted shadow
            minWidth: "150px", // Set a min width
            display: "flex",
            flexDirection: "column",
            gap: "8px", // Adjusted gap
          },
        },
      }}
    >
      <Link
        className="popover-menu-item !mx-[8px] flex max-w-full cursor-pointer flex-row flex-nowrap items-center gap-[8px] !text-red !no-underline"
        onClick={handleLogout}
      >
        {logoutLoading ? (
          <LoadingImage className="!h-[20px]" />
        ) : (
          <>
            <img
              src={require("assets/log-out-red.svg").default}
              alt="logout"
              className="h-[16px] w-[16px] text-red"
            />
            <span className="text-red">{t("logout")}</span>
          </>
        )}
      </Link>
    </Popover>
  );
};

export default AssignmentProfilePopup;